// Types for Carrier Directory components
// Aligned with CARRIER_DIRECTORY_PROJECT.md

export type HealthCarrierType =
  | 'CLASSIC_MEDICARE'
  | 'MEDICARE_ADVANTAGE'
  | 'MEDICAID_TRADITIONAL'
  | 'MEDICAID_MCO'
  | 'COMMERCIAL_EMPLOYER'
  | 'COMMERCIAL_INDIVIDUAL'
  | 'BLUES_COMMERCIAL'
  | 'TRICARE'
  | 'VETERANS_ADMINISTRATION'
  | 'WORKERS_COMP';

export const HEALTH_CARRIER_TYPE_OPTIONS: {
  value: HealthCarrierType;
  label: string;
}[] = [
  { value: 'CLASSIC_MEDICARE', label: 'Medicare' },
  { value: 'MEDICARE_ADVANTAGE', label: 'Medicare Advantage' },
  { value: 'MEDICAID_TRADITIONAL', label: 'Medicaid' },
  { value: 'MEDICAID_MCO', label: 'Medicaid (MCO)' },
  { value: 'COMMERCIAL_EMPLOYER', label: 'Commercial (Employer)' },
  { value: 'COMMERCIAL_INDIVIDUAL', label: 'Commercial (Individual)' },
  { value: 'BLUES_COMMERCIAL', label: 'Blue Cross Blue Shield' },
  { value: 'TRICARE', label: 'TRICARE' },
  { value: 'VETERANS_ADMINISTRATION', label: 'Dept. of Veterans Affairs' },
  { value: 'WORKERS_COMP', label: "Workers' Compensation" },
];

export type HandleType =
  | 'PHONE'
  | 'EMAIL'
  | 'WEBSITE'
  | 'FAX'
  | 'MAILING_ADDRESS';
export type HandleSource = 'web_search' | 'manual' | 'document' | 'import';

export interface ContactHandle {
  id: string;

  // Simple value (for PHONE, EMAIL, WEBSITE, FAX)
  value?: string | null;

  // Inline address fields (for MAILING_ADDRESS)
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  country?: string | null;

  handleType: HandleType;
  name: string; // User-facing label like "Florida BI Claims"
  description?: string | null; // Optional description
  source?: HandleSource | null; // Optional - may not be set yet

  // Usage tracking
  lastUsedAt?: string | null;
  usageCount?: number;

  // Audit fields
  createdByUserId?: string | null;
  archivedAt?: string | null; // Soft delete
  archivedByUserId?: string | null;
  // Division assignment
  divisionId?: string | null;
}

export interface Carrier {
  id: string;
  name: string;
  normalizedName: string; // Computed for matching: "statefarm"
  aliases?: string[]; // Optional: ["State Farm Insurance", "State Farm Mutual"]
  handles: ContactHandle[];

  // Address fields
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;

  // Health carrier type
  healthCarrierType?: HealthCarrierType | null;

  // Audit fields
  createdByUserId?: string | null;
  archivedAt?: string | null; // Soft delete
  archivedByUserId?: string | null;
}
